import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import ObrasLogged from '../../../components/auth/obras'

function ObrasLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Obras Públicas" />
                <HeaderLogged />
                <Container>
                   <ObrasLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default ObrasLoggedScreen;